import React from "react";
import "./02_Google_Colab.css";
import TopicFrame from "../../../components/TopicFrame/TopicFrame";
import Subtopic from "../../../components/Subtopic/Subtopic";
import Subsubtopic from "../../../components/Subsubtopic/Subsubtopic";
import GoogleImage from "../../../assets/images/SIGA_Jupyter_Notebook/konto.png";
import GoogleColabImage from "../../../assets/images/SIGA_Jupyter_Notebook/colab.png";

const SigaPage = () => {
  return (
    <>
      <TopicFrame topicType="signalTheorie" entryNumber={1}>
        <Subtopic id="SinCos" Title="Umgebungseinrichtung für das Praktikum">
          <div id="Umgebungseinrichtung">
            <Subsubtopic Title="Python">
              <div className="bodyText">
                Wir arbeiten mit Python. Diese Programmiersprache ist von Google entwickelt worden und bietet als
                gescriptete, interpretierte Sprache eine Platform um schnell Ideen umzusetzen und Konzepte zu
                realisieren. Also so genannte Proof of Concepts. Wie wir hier auch merken werden ist Python eigentlich
                sehr langsam. Die Stärke liegt darin, dass Python erlaubt, sehr einfach Module aus anderen
                Programmiersprachen nutzbar zu machen. Python kümmert sich dabei um den Programmablauf und die
                bespielsweise native C Anwendung führt die Berechnung durch.
              </div>
            </Subsubtopic>
            <Subsubtopic Title="Google Konto">
              <div className="flex">
                <img src={GoogleImage} alt="Bild Konto" />
                <div className="bodyText">
                  Um am Praktikum teilzunehmen und Google Colab zu nutzen, ist ein Google-Konto erforderlich. Falls
                  notwendig, erstelle einen temporären E-Mail-Account, um dich anschließend auf
                  <a href="https://colab.research.google.com/" target="_blank" rel="noopener noreferrer">
                    https://colab.research.google.com/
                  </a>
                  bei Google Colab anzumelden.
                </div>
              </div>
            </Subsubtopic>
            <Subsubtopic Title="Google Colab">
              <div className="bodyText flex">
                Google Colab ist eine Online-Plattform für Programmierung, die es Nutzern ermöglicht, Python-Code in
                einer browserbasierten Umgebung auszuführen. Diese Plattform ist kostenlos verfügbar, bietet jedoch auch
                kostenpflichtige Optionen für erweiterte Funktionen und Ressourcen. Um Google Colab nutzen zu können,
                wird lediglich ein Google-Konto und einen Webbrowser benötigt, der Javascript unterstützt. Theoretisch
                wäre es somit möglich, Google Colab auch auf unkonventionellen Geräten wie einer Smartwatch in
                Verbindung mit einem RaspberryPi zu nutzen.
                <img src={GoogleColabImage} alt="Bild Google Colab" />
              </div>
            </Subsubtopic>
            <Subsubtopic Title="Jupyter Notebook">
              <div className="bodyText">
                Ein Jupyter Notebook ist eine eigenständige Datei. Mittlerweile lässt es sich direkt in Visual Studio
                Code öffnen, lokal auf dem eigenen Computer über einen Server betreiben oder sogar über den Webbrowser
                unter Zuhilfenahme externer Ressourcen nutzen. In unserem Praktikum nutzen wir die kostenfreien
                Rechenkapazitäten von Google und führen unsere Programmierung direkt im Webbrowser durch.
                <br></br>
                Um ein neues Notebook zu erstellen oder ein bereits vorhandenes aufzurufen, navigiert man zum Menü
                <span className="monoFont"> File </span> oben links. Die für das Praktikum erforderlichen Jupyter
                Notebook-Dateien befinden sich im Notebook-Ordner des Signaltheorie-Kurses auf Ilu.
                <br></br>
                Zur Interaktion mit dem Notebook können nun unterschiedliche Zellentypen wie Markdown, Python oder
                einfache Textzellen erstellt werden. Nach Erstellung können diese Blöcke durch Drücken von{" "}
                <span className="monoFont"> SHIFT+ENTER </span> ausgeführt bzw. gerendert werden. Alternativ können die
                ausgewählten Zelle auch über den Menüpunkt <span className="monoFont"> LAUFZEIT </span> ausgeführt
                werden.
              </div>
            </Subsubtopic>
            <Subsubtopic Title="Google Drive">
              <div className="bodyText">
                Für spätere Praktika wird es nötig sein, auf externe Dateien zugreifen zu können. In Google Colab haben
                wir die Möglichkeit, dies mit Dateien, welche in Google Drive hinterlegt sind, umzusetzen.
                <br></br>
                Um unser Google Drive mit dem entsprechenden Jupyter Notebook zu verknüpfen, benötigen wir folgende
                Codezeilen:
                <br></br>
                <span className="monoFont"> from google.colab import drive </span>
                <br></br>
                <span className="monoFont"> drive.mount('/content/gdrive') </span>
                <br></br>
                Über <span className="monoFont"> datei = read('/content/gdrive/My Drive/Pfad/zur/Datei') </span>
                kann nun auf eine Datei zugegriffen werden.
              </div>
            </Subsubtopic>
          </div>
        </Subtopic>
      </TopicFrame>
    </>
  );
};

export default SigaPage;
